var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{staticClass:"align-self-start commons-nav",attrs:{"gap":"1"}},_vm._l((_vm.numOfLevels),function(lvl){return _c('commons-navigation-button',{key:lvl,attrs:{"level":lvl - 1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }